/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FileFormat {
  Unknown = 0,
  Excel = 1,
  Pdf = 2,
}
